import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const getAttachments = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("attachments", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAttachmentsBase64 = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("attachments/base64", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};


export const postAttachment = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("attachments", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putAttachment = async ({ id, payload }) => {
  try {
    const reqOpts = getAPIHeaders({ ATTACHMENT_ID: id });
    const response = await serverApi.put(`attachments`, payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
